import clsx from "clsx";
import { CheckboxField, Checkbox } from "V2.0/common/checkbox";

export default SectionCheckboxField;

type Section = {
  name: string;
  isChecked: boolean;
  label: string;
};

interface SectionCheckboxFieldProps {
  section: Section;
  disabled: boolean;
  isFirst: boolean;
  onHideSection: (section: string) => void;
  onUnhideSection: (section: string) => void;
}

function SectionCheckboxField(props: SectionCheckboxFieldProps) {
  const { section, disabled, isFirst, onHideSection, onUnhideSection } = props;
  return (
    <CheckboxField className={clsx(isFirst && "mt-4 mx-2")}>
      <Checkbox
        color="blue"
        name={section.name}
        checked={section.isChecked}
        onChange={() => {
          section.isChecked
            ? onHideSection(section.name)
            : onUnhideSection(section.name);
        }}
      />
      <p
        className={clsx(
          "text-sm hover:cursor-pointer hover:font-medium",
          section.isChecked && !disabled && "text-zinc-700 font-medium",
          "text-gray-500",
        )}
      >
        {section.label}
      </p>
    </CheckboxField>
  );
}
